import { styled } from 'baseui';
import { COLORS } from './constants';

// ── Gamification ────────────────────────────────────────────────────────────────

export const HeaderRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '4rem',
  marginBottom: '2rem',
  flexShrink: 0,
});

export const HeaderLeft = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  flex: 1,
});

export const Avatar = styled('img', {
  width: '4rem',
  height: '4rem',
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
});

export const NameColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

export const UserName = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1.875rem',
  lineHeight: 1,
  color: COLORS.textStrong,
  letterSpacing: '-0.01875rem',
});

export const DateRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.375rem',
});

export const CalendarIcon = styled('img', {
  width: '1rem',
  height: '1rem',
});

export const DateText = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontSize: '0.875rem',
  color: COLORS.textMedium,
});

export const ContentArea = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flex: 1,
});

export const NotificationWrapper = styled('div', {
  position: 'fixed',
  top: '1.25rem',
  right: '1.25rem',
  zIndex: 1000,
});

// ── CategoryProgressList ────────────────────────────────────────────────────────

export const ListWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  maxWidth: '45.625rem',
});

export const Subtitle = styled('p', {
  fontFamily: '"Inter", sans-serif',
  fontSize: '0.875rem',
  lineHeight: 1.5,
  color: COLORS.textMedium,
  margin: '0 0 1.5rem 0',
});

export const RowsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.875rem',
  padding: '0 0.5rem',
});

export const CategoryRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
});

export const ProgressCell = styled('div', {
  flex: 1,
  minWidth: 0,
});

export const TrophyCell = styled('div', {
  width: '5rem',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'visible',
});

// ── CategoryProgressItem ────────────────────────────────────────────────────────

export const ItemWrapper = styled('div', ({ $clickable }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  cursor: $clickable ? 'pointer' : 'default',
  ':hover': $clickable
    ? { backgroundColor: 'rgba(0, 0, 0, 0.02)', borderRadius: '0.5rem' }
    : {},
  transition: 'background-color 0.2s ease',
}));

export const ItemHeader = styled('div', {
  display: 'flex',
  alignItems: 'center',
  height: '1.8125rem',
});

export const CategoryName = styled('span', {
  flex: 1,
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1.125rem',
  lineHeight: 1.6,
  color: COLORS.textStrong,
  letterSpacing: '-0.01575rem',
});

export const CounterWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const CountAcquired = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1.125rem',
  lineHeight: 1.6,
  color: COLORS.textWeak,
});

export const CountSeparator = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1.125rem',
  lineHeight: 1.6,
  color: COLORS.textMedium,
});

export const CountTotal = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1.125rem',
  lineHeight: 1.6,
  color: COLORS.textStrong,
});

export const ProgressBarWrapper = styled('div', {
  position: 'relative',
  width: '100%',
  height: '1.5rem',
  display: 'flex',
  alignItems: 'center',
});

export const Track = styled('div', {
  width: '100%',
  height: '0.625rem',
  backgroundColor: COLORS.progressGray,
  borderRadius: '0.3125rem',
  overflow: 'hidden',
});

export const Fill = styled('div', ({ $width, $color }) => ({
  width: `${$width}%`,
  height: '100%',
  backgroundColor: $color || COLORS.progressGreen,
  borderRadius: '0.3125rem',
  transition: 'width 0.5s ease',
}));

export const TrophyMarker = styled('div', ({ $left }) => ({
  position: 'absolute',
  left: $left,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  transition: 'left 0.5s ease',
  zIndex: 2,
  pointerEvents: 'none',
}));

// ── TrophyBadge ─────────────────────────────────────────────────────────────────

export const TrophyContainer = styled('div', ({ $width, $height }) => ({
  position: 'relative',
  width: `${$width / 16}rem`,
  height: `${$height / 16}rem`,
  flexShrink: 0,
}));

export const LayerImg = styled('img', {
  objectFit: 'contain',
});
